import u from "updeep";

import * as actions from "./actionTypes";

const initialState = {
  count: 0,
  data: [],
  error: "",
  filters: {},
  loading: true
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case actions.FETCH:
      return u(
        {
          error: "",
          loading: true,
          filters: action.filters
        },
        state
      );
    case actions.FETCH_OK:
      return u(
        {
          error: "",
          loading: false,
          data: action.payload.results || [],
          count: parseInt(action.payload.pagination.count) || 0
        },
        state
      );
    case actions.FETCH_FAILED:
      return u(
        {
          loading: false,
          ...action.payload
        },
        state
      );
    default:
      return state;
  }
};
